<div class="app-wrapper">
  <router-outlet></router-outlet>
</div>

<ssc-dev-tools></ssc-dev-tools>
